// extracted by mini-css-extract-plugin
export default {"tabbar":"TabBar_tabbar__3cJFB","hide":"TabBar_hide__0K030","tab":"TabBar_tab__Grbge","active":"TabBar_active__Bjycm"};